var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPredictiveAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.211 89.2611C165.646 89.6214 170.694 92.671 173.445 98.8277C176.164 104.911 175.313 110.786 170.939 115.835C166.576 120.875 160.959 122.535 154.492 120.765C153.292 120.436 152.723 120.718 151.997 121.58C148.521 125.721 144.998 129.825 141.443 133.903C140.854 134.582 140.707 135.078 141.104 135.945C144.017 142.285 143.103 148.922 138.458 153.768C133.692 158.739 127.888 160.175 121.348 157.982C115.152 155.909 111.065 150.316 110.69 143.59C110.643 142.749 110.309 142.446 109.62 142.191C104.097 140.138 98.575 138.07 93.0684 135.966C92.2332 135.648 91.8157 135.856 91.2728 136.525C86.1159 142.849 78.986 144.525 71.5272 141.178C70.8173 140.859 70.3632 140.864 69.7578 141.386C65.4673 145.115 61.1507 148.817 56.808 152.493C56.1817 153.021 56.1608 153.449 56.3748 154.196C59.5431 165.465 51.1343 175.815 39.5521 174.958C32.0673 174.405 25.4541 167.715 25.0313 160.285C24.5615 151.966 29.9011 144.775 37.6992 143.198C41.2589 142.478 44.6882 142.828 47.9295 144.483C48.7438 144.901 49.2657 144.838 49.9756 144.217C54.1721 140.551 58.4156 136.932 62.6696 133.329C63.3012 132.791 63.463 132.368 63.2177 131.507C60.6079 122.384 65.7857 113.277 74.7372 111.141C83.7723 108.99 92.3115 114.614 94.2375 124.018C94.3785 124.702 94.6499 125.094 95.2971 125.334C101.394 127.601 107.485 129.872 113.566 132.18C114.234 132.431 114.63 132.352 115.147 131.83C119.803 127.141 125.315 125.668 131.662 127.606C132.346 127.815 132.669 127.632 133.071 127.162C136.798 122.791 140.519 118.42 144.288 114.086C144.852 113.439 144.732 112.953 144.403 112.305C139.658 102.958 145.395 91.1671 156.591 89.423C157.358 89.3029 158.146 89.3185 159.206 89.2559L159.211 89.2611Z",
    fill: "url(#paint0_linear_75_317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5358 25.0521C95.6886 25.0521 112.584 39.4333 115.549 59.073C117.251 70.3471 114.557 80.6343 107.636 89.7466C107.083 90.4777 106.848 90.9268 107.652 91.6578C108.299 92.2479 108.607 92.227 109.223 91.6369C112.637 88.3785 115.215 88.4463 118.54 91.7884C121.886 95.1461 125.263 98.4725 128.582 101.856C131.771 105.11 132.888 109.016 131.563 113.381C130.258 117.668 127.257 120.352 122.841 121.235C119.109 121.982 115.711 121.026 112.965 118.389C109.066 114.645 105.251 110.807 101.482 106.927C99.1283 104.504 99.3632 101.449 102.056 98.8223C102.918 97.9816 102.881 97.5273 102.036 96.7597C101.341 96.1278 100.986 96.5612 100.501 96.932C95.6729 100.671 90.2707 103.151 84.3099 104.504C62.5548 109.449 40.095 94.4777 36.3682 72.5038C32.6675 50.6604 45.8365 30.885 67.4194 25.9189C70.191 25.2819 73.0148 24.9476 75.5411 25.0521H75.5358ZM110.643 65.2453C110.669 46.1174 95.0205 30.4255 75.8908 30.3941C56.7767 30.3628 41.0815 46.0286 41.0554 65.1618C41.0293 84.2845 56.6828 99.9868 75.8073 100.013C94.9161 100.044 110.617 84.3732 110.643 65.2401V65.2453Z",
    fill: "url(#paint1_linear_75_317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.474 60.5144C153.365 54.1019 155.782 49.0732 161.419 45.7311C163.841 44.2951 164.723 41.7155 163.804 39.2612C162.969 37.0209 160.521 35.4909 158.271 35.7886C155.604 36.1437 153.506 38.2011 153.527 40.9896C153.548 43.7677 150.995 46.6136 147.989 46.4779C145.128 46.3473 142.842 44.1228 142.774 41.235C142.586 33.1828 148.892 26.0288 156.992 25.1045C165.161 24.1698 172.949 29.7886 174.541 37.7625C175.924 44.7076 173.105 51.2507 166.998 54.9217C165.057 56.0914 164.232 57.7155 164.175 59.8669C164.154 60.8121 164.19 61.7625 164.164 62.7076C164.075 65.6685 161.711 67.9087 158.731 67.8773C155.86 67.846 153.563 65.5797 153.48 62.692C153.459 61.9661 153.48 61.2403 153.48 60.5196L153.474 60.5144Z",
    fill: "url(#paint2_linear_75_317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.164 78.53C164.185 81.5535 161.841 83.94 158.835 83.94C155.818 83.94 153.464 81.5796 153.469 78.5614C153.474 75.6005 155.771 73.2768 158.71 73.2454C161.758 73.2141 164.138 75.5222 164.159 78.53H164.164Z",
    fill: "url(#paint3_linear_75_317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7394 94.6557C59.4857 94.64 46.4107 81.4755 46.4159 65.1361C46.4263 48.7862 59.5849 35.7366 76.0422 35.7627C92.2698 35.7888 105.303 48.9847 105.282 65.3606C105.261 81.6061 92.0819 94.6713 75.7394 94.6557Z",
    fill: "url(#paint4_linear_75_317)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_317",
    x1: 100.002,
    y1: 89.2559,
    x2: 100.002,
    y2: 175.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_317",
    x1: 83.9288,
    y1: 25.0332,
    x2: 83.9288,
    y2: 121.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_317",
    x1: 158.828,
    y1: 25.0029,
    x2: 158.828,
    y2: 67.8777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_317",
    x1: 158.817,
    y1: 73.2451,
    x2: 158.817,
    y2: 83.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_317",
    x1: 75.8491,
    y1: 35.7627,
    x2: 75.8491,
    y2: 94.6557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictiveAnalysis);
export default __webpack_public_path__ + "static/media/Predictive_Analysis.572332c9f94676034b75f8d625993a32.svg";
export { ForwardRef as ReactComponent };